import { render } from "./OurTeam.vue?vue&type=template&id=0e9083b9&scoped=true&ts=true"
import script from "./OurTeam.vue?vue&type=script&lang=ts"
export * from "./OurTeam.vue?vue&type=script&lang=ts"

import "./OurTeam.vue?vue&type=style&index=0&id=0e9083b9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e9083b9"]])

export default __exports__